/*
 * Copyright (c) 2023 Your Company Name
 * All rights reserved.
 */
/*
 *   Copyright (c) 2023
 *   All rights reserved.
 */
/*eslint-disable*/
import React, { useEffect, useState } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormLabel from "@material-ui/core/FormLabel";
import Checkbox from "@material-ui/core/Checkbox";
import InputAdornment from "@material-ui/core/InputAdornment";

// material ui icons
import MailOutline from "@material-ui/icons/MailOutline";
import Contacts from "@material-ui/icons/Contacts";
import Check from "@material-ui/icons/Check";
import Close from "@material-ui/icons/Close";

import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardText from "components/Card/CardText.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import SweetAlert from "react-bootstrap-sweetalert";
import {
  addVehiculeAction,
  upadateVehiculeAction,
} from "action/vehiculeAction";

// style for this view
import stylesExtended from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js";
import styles from "assets/jss/material-dashboard-pro-react/views/validationFormsStyle.js";
import { useHistory } from "react-router";
import { connect } from "react-redux";

import * as service from "../../services/vehiculeService";
import * as notif from "components/Notification/notification";
import { useMemo } from "react";
import * as serviceDevice from "../../services/deviceService";
import { useParams } from "react-router-dom-v5-compat";

const useStyles = makeStyles(styles);
const useStylesExtended = makeStyles(stylesExtended);

const VehiculeUpdate = (props) => {
  //const [listDeviceState, setListDeviceState] = useState()
  //const [deviceSelectElem, setDeviceSelectElem] = useState()
  const [typeVehiculeSelectFinal, setTypeVehiculeSelectFinal] = useState("");

  const [paramClientId, setParamClientId] = useState("");
  const [paramVehiculeId, setParamVehiculeId] = useState(0);

  const [listDeviceState, setListDeviceState] = useState();
  const [deviceSelectElem, setDeviceSelectElem] = useState();
  const [deviceSelectFinal, setDeviceSelectFinal] = useState("");

  const [deviceSelectSuplementaire, setDeviceSelectSuplementaire] = useState(
    ""
  );

  const [openNotif, setOpenNotif] = useState(false);

  // type validation
  const [marqueVehicule, setMarqueVehicule] = React.useState("");
  const [marqueVehiculeState, setMarqueVehiculeState] = React.useState("");

  const [modele, setModele] = React.useState("");
  const [modeleState, setModeleState] = React.useState("");

  const [matriculeVehicule, setMatriculeVehicule] = React.useState("");
  const [matriculeVehiculeState, setMatriculeVehiculeState] = React.useState(
    ""
  );

  const [anneeVehicule, setAnneeVehicule] = React.useState("");
  const [anneeVehiculeState, setAnneeVehiculeState] = React.useState("");

  const [kilometreVehicule, setKilometreVehicule] = React.useState("");
  const [kilometreVehiculeState, setKilometreVehiculeState] = React.useState(
    ""
  );

  const [puissance, setPuissance] = React.useState("");
  const [puissanceState, setPuissanceState] = React.useState("");

  const [activeVehiculeSelect, setActiveVehiculeSelect] = React.useState(true);

  const paramURLClientID = useParams().id;
  const paramURLVehiculeID = useParams().vehiculeId;

  useEffect(() => {
    setParamClientId(paramURLClientID);
    setParamVehiculeId(paramURLVehiculeID || 0);
  }, []);

  const handleDevice = (event) => {
    setDeviceSelectFinal(event.target.value);
  };

  const handleTypeVehicule = (event) => {
    setTypeVehiculeSelectFinal(event.target.value);
  };

  //handleTypeVehicule

  const handleActiveVehicule = (event) => {
    setActiveVehiculeSelect(event.target.value);
  };

  useEffect(() => {
    if (openNotif === true) {
      if (props.loadVehiculeFromSaga.loading === false) {
        let msg;
        let title;

        if (props.loadVehiculeFromSaga.error.length > 0) {
          if (paramVehiculeId) {
            title = "Echeque Mise a jour vehicule";
            msg = "Mise a jours vehicule echoué";
          } else {
            title = "Echeque ajout vehicule";
            msg = "La vehicule " + anneeVehicule + " n a pas ete ajouter";
          }
          notif.showFailedNotification(title, msg);
        } else {
          if (paramVehiculeId) {
            title = "Mise a jour vehicule";
            msg = "La vehicule " + anneeVehicule + "  a ete mise a jours";
          } else {
            title = "Ajout  vehicule";
            msg = "La vehicule " + anneeVehicule + " a ete ajouter";
          }
          notif.showSuccessNotification(title, msg);
        }
        setOpenNotif(false);
      }
    }
  }, [props.loadVehiculeFromSaga]);

  useEffect(() => {
    if (paramVehiculeId) {
      const data = {
        numeroVehicule: paramVehiculeId,
      };
      /*
anneeVehicule: "2013"
idClient: 1
identifiantVehicule: 1
marque: "Piagiot"
modele: "Liberty"
nombreChevaux: "12ch"
nombreKilometrage: "122222"
numeroImmatriculation: "DK1213BA"
typeVehicule: "Voiture"
*/

      service
        .getItemVehicule(data)
        .then((res) => {
          // console.log(res)

          if (res.idDevice !== undefined) {
            //// console.log("idDevice =  ", res.idDevice," et ", res.numeroDevice )
            setDeviceSelectSuplementaire(
              <MenuItem
                classes={{
                  root: classesExtended.selectMenuItem,
                  selected: classesExtended.selectMenuItemSelected,
                }}
                // selected={(deviceSelectFinal === device.identifiantDevice) ? true : false }
                value={res.idDevice}
              >
                {res.numeroDevice}
              </MenuItem>
            );
            //// console.log('res.device.numeroCartedevice', res.device.numeroDeSeriedevice)
            setDeviceSelectFinal(res.idDevice);
          }

          setModele(res.modele);
          if (verifyLength(res.modele, 0)) {
            setModeleState("success");
          }
          setMarqueVehicule(res.marque);
          if (verifyLength(res.marque, 0)) {
            setMarqueVehiculeState("success");
          }
          setMatriculeVehicule(res.numeroImmatriculation);
          if (verifyLength(res.numeroImmatriculation, 0)) {
            setMatriculeVehiculeState("success");
          }
          setAnneeVehicule(res.anneeVehicule);
          if (verifyLength(res.anneeVehicule, 0)) {
            setAnneeVehiculeState("success");
          }

          setPuissance(res.nombreChevaux);
          if (verifyLength(res.nombreChevaux, 0)) {
            setPuissanceState("success");
          }

          setKilometreVehicule(res.nombreKilometrage);
          if (verifyLength(res.nombreKilometrage, 0)) {
            setKilometreVehiculeState("success");
          }

          setTypeVehiculeSelectFinal(res.typeVehicule);

          if (res.active != undefined) {
            setActiveVehiculeSelect(res.active);
          }

          // console.log(res)
          /* 
            
            
            
            
            //setactivation(res.type)
            setactivationState("success");
*/
        })
        .catch((error) => {
          //// console.log('error = ',error)
        });
    }
  }, [paramClientId]);

  const successDelete = () => {
    setAlert(
      <SweetAlert
        success
        style={{ display: "block", marginTop: "-100px" }}
        title="Deleted!"
        onConfirm={() => hideAlert()}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + " " + classes.success}
      >
        Your imaginary file has been deleted.
      </SweetAlert>
    );
  };
  const cancelDetele = () => {
    setAlert(
      <SweetAlert
        danger
        style={{ display: "block", marginTop: "-100px" }}
        title="Cancelled"
        onConfirm={() => hideAlert()}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + " " + classes.success}
      >
        Your imaginary file is safe :)
      </SweetAlert>
    );
  };
  const hideAlert = () => {
    setAlert(null);
  };

  // function that verifies if a string has a given length or not
  const verifyLength = (value, length) => {
    if (value.length > length) {
      return true;
    }
    return false;
  };
  // function that verifies if value contains only numbers
  const verifyNumber = (value) => {
    var numberRex = new RegExp("^[0-9]+$");
    if (numberRex.test(value)) {
      return true;
    }
    return false;
  };

  const typeClick = () => {
    let error = false;

    if (marqueVehicule === "") {
      setMarqueVehiculeState("error");
      error = true;
    }

    if (modele === "") {
      error = true;
      setModeleState("error");
    }

    if (matriculeVehicule === "") {
      error = true;
      setMatriculeVehiculeState("error");
    }

    if (anneeVehicule === "") {
      error = true;
      setAnneeVehiculeState("error");
    }

    if (kilometreVehicule === "") {
      error = true;
      setKilometreVehiculeState("error");
    }

    if (puissance === "") {
      error = true;
      setPuissanceState("error");
    }

    if (activeVehiculeSelect === "") {
      error = true;
    }
    if (deviceSelectFinal === "") {
      error = true;
    }

    /*
{

  "identifiantVehicule": 4,
    "anneeVehicule": "2013",
    "marque": "Piagiot",
    "modele": "Liberty",
    "nombreChevaux": "12ch",
    "nombreKilometrage": "122222",
    "numeroImmatriculation": "DK2222BA",
    "Puissance": "Voiture",
    "photoVehicule": null

  
*/
    let data = {
      identifiantVehicule: paramVehiculeId,
      anneeVehicule: anneeVehicule,
      marque: marqueVehicule,
      modele: modele,
      nombreChevaux: puissance,
      //"nombreChevaux": "12ch",
      nombreKilometrage: kilometreVehicule,
      numeroImmatriculation: matriculeVehicule,
      typeVehicule: typeVehiculeSelectFinal,
      idClient: paramClientId,
      idDevice: deviceSelectFinal,
      active: activeVehiculeSelect,
    };

    // console.log('DATA = ' ,data)

    if (error === false) {
      setOpenNotif(true);
      if (paramVehiculeId) {
        props.vehiculeUpdateDispatch(data);
      } else {
        props.vehiculeAddDispatch(data);
      }

      //history('/')
    }
  };

  const classes = useStyles();
  const classesExtended = useStylesExtended();

  /*
        
etatVehicule: "1"
telephone1: "555555"
telephone2: "555555"
type: "333333"
        */

  const selectDevice = async () => {
    const listDevice = await serviceDevice.getListUnusedDevice();
    setListDeviceState(listDevice);
  };

  useEffect(() => {
    selectDevice();
  }, []);

  useEffect(() => {
    if (listDeviceState !== undefined) {
      const devices = listDeviceState.map((device) => {
        return (
          <MenuItem
            key={device.identifiantDevice}
            classes={{
              root: classesExtended.selectMenuItem,
              selected: classesExtended.selectMenuItemSelected,
            }}
            selected={
              deviceSelectFinal === device.identifiantDevice ? true : false
            }
            value={device.identifiantDevice}
          >
            {device.numeroDevice}
          </MenuItem>
        );
      });

      const deviceElem = () => {
        return (
          <Select
            MenuProps={{
              className: classesExtended.selectMenu,
            }}
            classes={{
              select: classesExtended.select,
            }}
            value={deviceSelectFinal}
            onChange={handleDevice}
            inputProps={{
              name: "deviceItem",
              id: "deviceItem",
            }}
          >
            <MenuItem
              disabled
              classes={{
                root: classesExtended.selectMenuItem,
              }}
            >
              Device
            </MenuItem>

            {devices}
            {deviceSelectSuplementaire}
          </Select>
        );
      };

      setDeviceSelectElem(deviceElem);
    }
  }, [listDeviceState, deviceSelectFinal]);

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="info" text>
            <CardText color="info">
              <h4 className={classes.cardTitle}>Vehicule</h4>
            </CardText>
          </CardHeader>
          <CardBody>
            <form>
              <GridContainer>
                <GridItem xs={12} sm={2}>
                  <FormLabel className={classes.labelHorizontal}>
                    marque
                  </FormLabel>
                </GridItem>
                <GridItem xs={12} sm={7}>
                  <CustomInput
                    success={marqueVehiculeState === "success"}
                    error={marqueVehiculeState === "error"}
                    id="marqueVehicule"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      onChange: (event) => {
                        if (verifyLength(event.target.value, 0)) {
                          setMarqueVehiculeState("success");
                        } else {
                          setMarqueVehiculeState("error");
                        }
                        setMarqueVehicule(event.target.value);
                      },
                      value: marqueVehicule,

                      type: "text",
                      endAdornment:
                        marqueVehiculeState === "error" ? (
                          <InputAdornment position="end">
                            <Close className={classes.danger} />
                          </InputAdornment>
                        ) : undefined,
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={3}>
                  <FormLabel className={classes.labelLeftHorizontal}>
                    <code>marque</code>
                  </FormLabel>
                </GridItem>
              </GridContainer>

              <GridContainer>
                <GridItem xs={12} sm={2}>
                  <FormLabel className={classes.labelHorizontal}>
                    modele
                  </FormLabel>
                </GridItem>
                <GridItem xs={12} sm={7}>
                  <CustomInput
                    success={modeleState === "success"}
                    error={modeleState === "error"}
                    id="modele"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      onChange: (event) => {
                        if (verifyLength(event.target.value, 0)) {
                          setModeleState("success");
                        } else {
                          setModeleState("error");
                        }
                        setModele(event.target.value);
                      },
                      value: modele,
                      type: "text",
                      endAdornment:
                        modeleState === "error" ? (
                          <InputAdornment position="end">
                            <Close className={classes.danger} />
                          </InputAdornment>
                        ) : undefined,
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={3}>
                  <FormLabel className={classes.labelLeftHorizontal}>
                    <code>modele</code>
                  </FormLabel>
                </GridItem>
              </GridContainer>

              <GridContainer>
                <GridItem xs={12} sm={2}>
                  <FormLabel className={classes.labelHorizontal}>
                    matricule
                  </FormLabel>
                </GridItem>
                <GridItem xs={12} sm={7}>
                  <CustomInput
                    success={matriculeVehiculeState === "success"}
                    error={matriculeVehiculeState === "error"}
                    id="matriculeVehicule"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      onChange: (event) => {
                        if (verifyLength(event.target.value, 0)) {
                          setMatriculeVehiculeState("success");
                        } else {
                          setMatriculeVehiculeState("error");
                        }
                        setMatriculeVehicule(event.target.value);
                      },
                      type: "text",
                      value: matriculeVehicule,
                      endAdornment:
                        matriculeVehiculeState === "error" ? (
                          <InputAdornment position="end">
                            <Close className={classes.danger} />
                          </InputAdornment>
                        ) : undefined,
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={3}>
                  <FormLabel className={classes.labelLeftHorizontal}>
                    <code>matricule</code>
                  </FormLabel>
                </GridItem>
              </GridContainer>

              <GridContainer>
                <GridItem xs={12} sm={2}>
                  <FormLabel className={classes.labelHorizontal}>
                    annee
                  </FormLabel>
                </GridItem>
                <GridItem xs={12} sm={7}>
                  <CustomInput
                    success={anneeVehiculeState === "success"}
                    error={anneeVehiculeState === "error"}
                    id="anneeVehicule"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      onChange: (event) => {
                        if (verifyLength(event.target.value, 0)) {
                          setAnneeVehiculeState("success");
                        } else {
                          setAnneeVehiculeState("error");
                        }

                        setAnneeVehicule(event.target.value);
                      },
                      type: "text",
                      value: anneeVehicule,
                      endAdornment:
                        anneeVehiculeState === "error" ? (
                          <InputAdornment position="end">
                            <Close className={classes.danger} />
                          </InputAdornment>
                        ) : undefined,
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={3}>
                  <FormLabel className={classes.labelLeftHorizontal}>
                    <code>annee</code>
                  </FormLabel>
                </GridItem>
              </GridContainer>

              <GridContainer>
                <GridItem xs={12} sm={2}>
                  <FormLabel className={classes.labelHorizontal}>
                    Kilometre
                  </FormLabel>
                </GridItem>
                <GridItem xs={12} sm={7}>
                  <CustomInput
                    success={kilometreVehiculeState === "success"}
                    error={kilometreVehiculeState === "error"}
                    id="kilometreVehicule"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      onChange: (event) => {
                        if (verifyLength(event.target.value, 0)) {
                          setKilometreVehiculeState("success");
                        } else {
                          setKilometreVehiculeState("error");
                        }

                        setKilometreVehicule(event.target.value);
                      },
                      type: "text",
                      value: kilometreVehicule,
                      endAdornment:
                        kilometreVehiculeState === "error" ? (
                          <InputAdornment position="end">
                            <Close className={classes.danger} />
                          </InputAdornment>
                        ) : undefined,
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={3}>
                  <FormLabel className={classes.labelLeftHorizontal}>
                    <code>Kilometre</code>
                  </FormLabel>
                </GridItem>
              </GridContainer>

              <GridContainer>
                <GridItem xs={12} sm={2}>
                  <FormLabel className={classes.labelHorizontal}>
                    Puissance
                  </FormLabel>
                </GridItem>
                <GridItem xs={12} sm={7}>
                  <CustomInput
                    success={puissanceState === "success"}
                    error={puissanceState === "error"}
                    id="puissance"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      onChange: (event) => {
                        if (verifyLength(event.target.value, 0)) {
                          setPuissanceState("success");
                        } else {
                          setPuissanceState("error");
                        }

                        setPuissance(event.target.value);
                      },
                      type: "text",
                      value: puissance,
                      endAdornment:
                        puissanceState === "error" ? (
                          <InputAdornment position="end">
                            <Close className={classes.danger} />
                          </InputAdornment>
                        ) : undefined,
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={3}>
                  <FormLabel className={classes.labelLeftHorizontal}>
                    <code>Puissasnce</code>
                  </FormLabel>
                </GridItem>
              </GridContainer>

              <GridContainer>
                <GridItem xs={12} sm={2}>
                  <FormLabel className={classes.labelHorizontal}>
                    device
                  </FormLabel>
                </GridItem>

                <GridItem xs={12} sm={7}>
                  <FormControl
                    fullWidth
                    className={classesExtended.selectFormControl}
                  >
                    <InputLabel
                      htmlFor="device-select"
                      className={classesExtended.selectLabel}
                    ></InputLabel>
                    {deviceSelectElem}
                  </FormControl>
                </GridItem>
              </GridContainer>

              <GridContainer>
                <GridItem xs={12} sm={2}>
                  <FormLabel className={classes.labelHorizontal}>
                    Type Vehicule
                  </FormLabel>
                </GridItem>

                <GridItem xs={12} sm={7}>
                  <FormControl
                    fullWidth
                    className={classesExtended.selectFormControl}
                  >
                    <InputLabel
                      htmlFor="TypeVehicule-select"
                      className={classesExtended.selectLabel}
                    ></InputLabel>

                    <Select
                      MenuProps={{
                        className: classesExtended.selectMenu,
                      }}
                      classes={{
                        select: classesExtended.select,
                      }}
                      value={typeVehiculeSelectFinal}
                      onChange={handleTypeVehicule}
                      inputProps={{
                        name: "typeVehiculeItem",
                        id: "typeVehiculeItem",
                      }}
                    >
                      <MenuItem
                        disabled
                        classes={{
                          root: classesExtended.selectMenuItem,
                        }}
                      >
                        Type vehicule
                      </MenuItem>

                      <MenuItem
                        classes={{
                          root: classesExtended.selectMenuItem,
                          selected: classesExtended.selectMenuItemSelected,
                        }}
                        selected={
                          typeVehiculeSelectFinal === "Voiture" ? true : false
                        }
                        value={"Voiture"}
                      >
                        {"Voiture"}
                      </MenuItem>

                      <MenuItem
                        classes={{
                          root: classesExtended.selectMenuItem,
                          selected: classesExtended.selectMenuItemSelected,
                        }}
                        selected={
                          typeVehiculeSelectFinal === "Moto" ? true : false
                        }
                        value={"Moto"}
                      >
                        {"Moto"}
                      </MenuItem>
                    </Select>
                  </FormControl>
                </GridItem>
              </GridContainer>

              <GridContainer>
                <GridItem xs={12} sm={2}>
                  <FormLabel className={classes.labelHorizontal}>
                    activation
                  </FormLabel>
                </GridItem>

                <GridItem xs={12} sm={7}>
                  <FormControl
                    fullWidth
                    className={classesExtended.selectFormControl}
                  >
                    <InputLabel
                      htmlFor="Vehiculeple-select"
                      className={classesExtended.selectLabel}
                    ></InputLabel>
                    <Select
                      MenuProps={{
                        className: classesExtended.selectMenu,
                      }}
                      classes={{
                        select: classesExtended.select,
                      }}
                      value={activeVehiculeSelect}
                      onChange={handleActiveVehicule}
                      inputProps={{
                        name: "VehiculepleSelect",
                        id: "Vehiculeple-select",
                      }}
                    >
                      <MenuItem
                        disabled
                        classes={{
                          root: classesExtended.selectMenuItem,
                        }}
                      >
                        Activation
                      </MenuItem>
                      <MenuItem
                        classes={{
                          root: classesExtended.selectMenuItem,
                          selected: classesExtended.selectMenuItemSelected,
                        }}
                        value={true}
                      >
                        Active
                      </MenuItem>

                      <MenuItem
                        classes={{
                          root: classesExtended.selectMenuItem,
                          selected: classesExtended.selectMenuItemSelected,
                        }}
                        value={false}
                      >
                        Desactiver
                      </MenuItem>
                    </Select>
                  </FormControl>
                </GridItem>
              </GridContainer>
            </form>
          </CardBody>
          <CardFooter className={classes.justifyContentCenter}>
            <Button color="info" onClick={typeClick}>
              Validate Inputs
            </Button>
          </CardFooter>
        </Card>
      </GridItem>
    </GridContainer>
  );
};

const mapStateToProps = (state) => {
  // console.log('state vehicule', state.vehicules)
  return {
    loadVehiculeFromSaga: state.vehicules,
  };
};

const mapsDispatchToProps = (dispatch) => {
  return {
    vehiculeAddDispatch: (data) => {
      dispatch(addVehiculeAction(data));
    },
    vehiculeUpdateDispatch: (data) => {
      dispatch(upadateVehiculeAction(data));
    },
  };
};

export default connect(mapStateToProps, mapsDispatchToProps)(VehiculeUpdate);
